import './Header.css';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'sq' : 'en');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className={`main-header${scrolled ? ' scrolled' : ''}`}>
        <div className="logo">
          <img src="/favicon.png" alt="ShalaAccounting Logo" />
        </div>
        
        <nav className="desktop-nav">
          <a href="#hero">{t('header.home')}</a>
          <a href="#about">{t('header.about')}</a>
          <a href="#services">{t('header.services')}</a>
        </nav>
        
        <div className="header-buttons">
          <button className="consult-btn" onClick={() => window.location='#contact'}>{t('header.consult')}</button>
          <button className="lang-btn" onClick={toggleLang} aria-label="Change language">
            {i18n.language === 'en' ? 'SQ' : 'EN'}
          </button>
        </div>
        
        <button className="hamburger-menu" onClick={toggleMenu}>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
      </header>
      
      <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
        <button className="close-menu-btn" onClick={closeMenu}>
          ×
        </button>
        <a href="#hero" onClick={closeMenu}>{t('header.home')}</a>
        <a href="#about" onClick={closeMenu}>{t('header.about')}</a>
        <a href="#services" onClick={closeMenu}>{t('header.services')}</a>
        <a href="#whyus" onClick={closeMenu}>{t('header.whyus')}</a>
        <a href="#contact" onClick={closeMenu}>{t('header.contact')}</a>
        <div className="menu-buttons">
          <button className="menu-consult-btn" onClick={() => { window.location='#contact'; closeMenu(); }}>
            {t('header.consult')}
          </button>
          <button className="menu-lang-btn" onClick={() => { toggleLang(); closeMenu(); }}>
            {i18n.language === 'en' ? 'SQ' : 'EN'}
          </button>
        </div>
      </nav>
      
      {isMenuOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}
    </>
  );
}

export default Header; 